module.exports = __webpack_public_path__ + "media/images/animated_loader-a2e35dd5.svg";